import { render, staticRenderFns } from "./MainSlider.vue?vue&type=template&id=21a7fb9a&scoped=true&"
import script from "./MainSlider.vue?vue&type=script&lang=js&"
export * from "./MainSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a7fb9a",
  null
  
)

export default component.exports